<template>
  <div id="app">
    <div :class="showNav ? 'content-with-nav' : 'content'">
        <router-view :key="$route.fullPath"></router-view>
    </div>
    <navigation-bar v-if="showNav" :items="navItems"></navigation-bar>
  </div>
</template>

<script>
const { publicPath } = process.env.CONFIG;
const projectUrl = window.location.origin + publicPath;
import { httpOpen } from "./scripts/network";
import { SHOW_NAV, NAV_SELECTED } from "./store/mutation-types";
export default {
  name: "app",
  data() {
    return {
      navItems: []
    };
  },
  computed: {
    showNav() {
      return this.$store.state.showNav;
    }
  },
  created() {
    this.$router.addIntercept(this.navCheck);
    this.loadNavConfig();
  },

  methods: {
    async loadNavConfig() {
      try {
        let ret = await httpOpen("/AssemblyPage/GetBottomNavigate", {
          type: "post"
        });
        this.navItems = ret.Data.map(item => {
          return {
            title: item.ButtonName,
            icon: item.ButtonIconUrl,
            selectedIcon: item.ButtonIconUrl2,
            url: item.ButtonLinkUrl
          };
        });
        this.navCheck(window.location.origin + window.location.pathname);
      } catch (e) {
        console.error(e);
      }
    },
    navCheck(to) {
      let url = "";
      if (typeof to === "string") {
        url = to;
      } else {
        url = projectUrl + to.path;
      }
      let index = this.navItems.findIndex(item => item.url === url);
      if (index >= 0) {
        this.$store.dispatch(SHOW_NAV, true);
        this.$store.dispatch(NAV_SELECTED, index);
      } else {
        this.$store.dispatch(SHOW_NAV, false);
      }
    }
  }
};
</script>

<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.content {
  width: 100%;
  overflow: hidden;
}

.content-with-nav {
  width: 100%;
  overflow: hidden;
}

@supports (padding-bottom: env(safe-area-inset-bottom)) {
  .content-with-nav {
    padding-bottom: env(safe-area-inset-bottom);
  }
}
.page {
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}

.content-with-nav .page {
  overflow: scroll;
  box-sizing: border-box;
}
.content-with-nav .page:after {
  content: "";
  padding-top: 63px;
  display: block;
}
</style>